export const DAY_OPTIONS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
] as const;

/** Fallback when tenant has no contact email. Multi-tenant placeholder for production. */
export const EMAIL_CONTACT = "contact@yourstudio.com";
